<template>
    <div @click="(event) => isOutside(event)">
       <modal :width="width" :height="height"  @hide-modal="close">
        <template v-slot:content>
            <div class="modal-inner w-full px-2" v-if="formSteps.length !== 0">
                <IntakeForm class="relative" v-if="formSteps[currentStep].formTitle" :fieldsToMonitor="['downsizeReason', 'downsizeSubReason']" :productPrices="productPrices" :steps="formatFormSteps(formSteps[currentStep].questions)" :buttonText="renewalsPersistedVariables.jsonContent.buttons.submit" :buttonStyling="'items-right'" @submitHandler="updateCartQuantities" :showButton="true" @progress="next" @hide-modal="$emit('hide-modal')">
                    <template v-slot:content>
                        <div class="text-left space-bottom-1">
                            <div class="text-2xl font-bold pb-1/2">{{formSteps[currentStep].formHeader}}</div>
                            <hr>
                        </div>
                    </template>
                </IntakeForm>
                <component
                    v-else
                    :is="formSteps[currentStep].type"
                    :isAnonymous='isAnonymousCustomer'
                    :step="formSteps[currentStep]"
                    :buttonStyling="'items-center'"
                    :showButton="true"
                    @progress="next"
                >
                <template v-slot:header-content>
                    <div class="text-center space-bottom-1">
                        <div class="text-2xl font-bold" v-if="formSteps[currentStep].title">{{formSteps[currentStep].title}}</div>
                        <div class="text-base space-top-1" v-if="formSteps[currentStep].subTitle">{{formSteps[currentStep].subTitle}}</div>
                    </div>
                </template>
                </component>
            </div>
        </template>
       </modal>
    </div>
            
</template>

<script>

import { mapMutations, mapGetters } from 'vuex';
import IntakeForm from '../webstore/IntakeForm.vue'
import Modal from '../../utils/modal';
import { WebstoreResources } from "../../../mixins/webstore-resources";
import informational from "../webstore/Information"
import dropdown from "../webstore/Dropdown"
import { getByContentType } from "../../../plugins/contentful";
import { analyticsTrack } from "../../../plugins/segment";

import axios from 'axios';
export default {
    components: {IntakeForm, Modal, informational, dropdown},
    mixins: [WebstoreResources],
    props:{
        productPrices:{
            type: Object, 
            required: true,
            default: {}
        },
        locale: {
            type: String,
            required: true,
        },
    },
    data() {
      return {
        formSteps: [],
        currentStep: 0
      }
    },
    computed: {
        ...mapGetters(['applicationVersion', 'typeOfRenewal', 'productSource']),
        ...mapGetters('checkout', ['renewalTerm', 'accountId', 'opptyId', 'writtenLanguage']),
        ...mapGetters('content', ['renewalsPersistedVariables']),
        ...mapGetters('shoppingCart', ['softwareCart']),
        ...mapGetters('billing', ['billing']),

        width() {
            return window.innerWidth > 550 ? '600px' : '90%';
        },
        height() {
            return window.innerWidth > 550 ? 'auto' : '90%';
        }
    },
    methods: {
        ...mapMutations('shoppingCart', 
        [
            'setProductCostsInfo',
            'setSoftwareCart'
        ]),
        formatFormSteps(formSteps) {
            return formSteps.map((step) => step.fields);
        },
        next(){
            this.currentStep++;
            if(this.currentStep === this.formSteps.length){
                this.$emit('hide-modal')
            }
        },
        isOutside(event) {
            if(!event.target.closest('.modal-inner')){
                analyticsTrack("Edit Quantity Modal Closed", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                this.$emit('hide-modal')
            }
        },
        close() {
            analyticsTrack("Edit Quantity Modal Closed", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
            this.$emit('hide-modal')
        },
        async updateCartQuantities(emittedFields){
            const updatedEntries = emittedFields['editQuantities']
            /*update shopping cart*/
            let payload = {"updatedEntries": updatedEntries, 
            "downsizeReason": emittedFields?.downsizeReason, 
            "downsizeReasonAdditional": emittedFields?.downsizeSubReason,
            "renewalTerm": this.renewalTerm}
            if (payload.downsizeReason && payload.downsizeReasonAdditional) {
                analyticsTrack("Renewal Downsizing Reason Submitted", {"accountId": this.accountId, "mainReason": payload.downsizeReason, "additionalReason": payload.downsizeReasonAdditional, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
            }
            try {
                let response = await axios({
                    method: 'POST',
                    url: '/checkout/update-shopping-cart',
                    data: payload,
                    headers: {'Content-type': 'application/json'}
                });
                
                
                if (response.data.software_cart) {
                    this.setSoftwareCart(response.data.software_cart);
                }
                if (response.data.product_costs_info) {
                    this.setProductCostsInfo(response.data.product_costs_info);
                    let originalQuantities = {};
                    let productCodesToNewQuantities = {};
                    this.softwareCart.forEach((license) => {
                        if (license.opportunity_line_item_number in updatedEntries) {
                            license.product_code in productCodesToNewQuantities ? productCodesToNewQuantities[license.product_code] += license.adjusted_quantity : productCodesToNewQuantities[license.product_code] = license.adjusted_quantity;
                            license.product_code in originalQuantities ? originalQuantities[license.product_code] += license.quantity : originalQuantities[license.product_code] = license.quantity;
                        }
                    });
                    analyticsTrack("Quantity Edited", {"accountId": this.accountId, "opptyId": this.opptyId, "updatedQuantities": productCodesToNewQuantities, "originalQuantities": originalQuantities, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                } else {
                    // track that no change was made
                    analyticsTrack("Edit Quantity Submit Button Clicked", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                }
                
            }
            catch(e){
                console.log(e)
            }
        }
    },
    async created(){
        const form = await getByContentType("anonymousPricingForm", this.locale, {include : 10, "fields.formTitle": "Renewals- Adjust Quantities Modal"});
        this.formSteps = this.formatFormSteps(form.questions);
     },
}
</script>

<style lang="scss" scoped>
input[type=tel] {
    border: 3px solid #0384FB;
    box-sizing: border-box;
}

hr.bottom-border {
    width:100% !important
}
</style>